export const DUPLICATE_ORG_NAME = 'DUPLICATE_ORG_NAME';
export const DUPLICATE_ORG_CODE = 'DUPLICATE_ORG_CODE';
export const DUPLICATE_ORG_NAME_MESSAGE =
  'Organisation already exists, please use a different name';
export const DUPLICATE_ORG_CODE_MESSAGE =
  'Organisation already exists, please use a different code';
export const SOMETHING_WENT_WRONG_MESSAGE = 'Something went wrong.';
export const OOPS_SOMETHING_WENT_WRONG_MESSAGE = 'Oops!, Something went wrong!';
export const DUPLICATE_CUSTOM_ROLE_MESSAGE =
  'Name already exists, please change the custom role name.';
export const CONFLICT = 'CONFLICT';
export const MAX_ORG_CODES = 3;
export const USERS_PER_PAGE = 10;
export const ORGNISATIONS_PER_PAGE = 10;
export const ROLES_N_PERMISSIONS_PER_PAGE = 10;
export const CUSTOM_ROLES_N_PERMISSIONS_PER_PAGE = 10;
export const DEACTIVATE_MEMBERSHIP_CONFIRMATION =
  'Are you sure you want to deactivate this member?';
export const ACTIVATE_MEMBERSHIP_CONFIRMATION =
  'Are you sure you want to activate this member?';

export const DISABLE_USER_CONFIRMATION_TITLE =
  'Are you sure you want to disable this user?';
export const DISABLE_USER_CONFIRMATION_DESCRIPTION =
  'User ":username" account will be disabled in CCL and Alef Platform (If has access)';
export const ENABLE_USER_CONFIRMATION =
  'Are you sure you want to enable this user?';
export const MEMBER_ENABLED_SUCCESS_MESSAGE = 'Member enabled successfully.';
export const MEMBER_DISABLED_SUCCESS_MESSAGE = 'Member disabled successfully.';
export const ADMIN_ENABLED_SUCCESS_MESSAGE = 'Admin enabled successfully.';
export const ADMIN_DISABLED_SUCCESS_MESSAGE = 'Admin disabled successfully.';
export const WEAK_PASSWORD_ERROR_MESSAGE =
  'Password is too weak, it should be at least 12 characters long and contain at least 1 number, 1 alphabet and 1 special character.';
export const PASSWORD_MISMATCH_ERROR_MESSAGE = 'Password mismatch';

// START: ---- messages: Verify email into platform ----

export const NEW_USER_MESSAGE = 'This user does not exist in the platform.';
export const EXISTING_USER_MESSAGE = 'This user exists in the platform.';
export const ORG_MEMBER_MESSAGE =
  'This user is already a member in the :code organisation.';
export const EXISTING_USER_IN_ALEF_MESSAGE =
  'This user already exist in Alef platform.';

// END: ---- messages: Verify email into platform ----

export const USER_ALREADY_MEMBER_CONFIRMATION_MESSAGE =
  'This user is already a member in this organisation. Do you want to edit?';
export const USER_EXIST_IN_PLATFORM_CONFIRMATION_MESSAGE =
  'This user already exist in the platform. Do you want to edit?';

export const DISABLE_USER = 'Disable User';
export const ENABLE_USER = 'Enable User';

export const ADMINS = 'Admins';
export const ORGANISATION = 'Organisation';
export const ORGANISATIONS = 'Organisations';
export const ORGANISATION_NAME = 'Organisation name';
export const MEMBERS = 'Members';
export const ADD_MEMBER = 'Add Member';
export const ADD_MEMBER_BUTTON_TEXT = 'Add member';
export const EDIT_MEMBER = 'Edit Member';
export const VIEW_MEMBER = 'View Member';
export const ROLES_AND_PERMISSIONS = 'Roles and Permissions';
export const PRODUCT_COURSE_MAP = 'Product Course Mapping';
export const BULK_UPLOAD = 'Bulk Upload';
export const SYSTEM_ROLE_LIST = 'System Role List';
export const CUSTOM_ROLE_LIST = 'Custom Role List';
export const MEMBERS_NAME = 'Member Name';
export const E_MAIL = 'E-mail';
export const STATUS = 'Status';
export const ACTIONS = 'Actions';
export const CODE = 'Code';
export const ROLE = 'Role';
export const COUNTRY = 'Country';
export const LOGOUT = 'Log out';
export const PROFILE_MENU = 'Profile menu';
export const NAME = 'Name';
export const ESISJOB = 'Esis Logs';

export const ACTIVE = 'Active';
export const INACTIVE = 'Inactive';
export const DEACTIVATE = 'deactivate';
export const ACTIVATE = 'activate';

export const ORG_NAME_VALIDATION_TEXT =
  'Name must be 3-128 character long and alphanumeric';
export const INVALID_EMAIL = 'Invalid email';

export const DUPLICATE_SOURCE_ID = 'DUPLICATE_ORG_SOURCEID';

export const DUPLICATE_SOURCE_ID_MESSAGE =
  'Source ID already exists, please use a different source ID';

export const ERROR_OCCURRED_WHILE_ADDING = 'Error occurred while adding';
export const ERROR_OCCURRED_WHILE_EDITING = 'Error occurred while editing';
export const ORGANISATION_SUCCESSFULLY_UPDATED =
  'Organisation was successfully updated';
export const ORGANISATION_SUCCESSFULLY_ADDED =
  'Organisation was successfully added';

export const SAVE = 'Save';

export const DELETE = 'Delete';
export const SEND = 'Send';
export const CANCEL = 'Cancel';
export const ADD_ORGANISATION = 'Add Organisation';
export const ADD_ORG_BUTTON_TEXT = 'Add organisation';
export const EDIT_ORGANISATION = 'Edit Organisation';
export const VIEW_ORGANISATION = 'View Organisation';
export const ACTIVATE_ORGANISATION = 'Activate Organisation';
export const DEACTIVATE_ORGANISATION = 'Deactivate Organisation';

export const MEMBERSHIP_SUCCESSFULLY_ACTIVATED_MESSAGE =
  'Membership activated successfully.';
export const MEMBERSHIP_SUCCESSFULLY_DEACTIVATED_MESSAGE =
  'Membership deactivated successfully.';
export const DEACTIVATE_MEMBERSHIP_TEXT = 'Deactivate Membership';
export const ACTIVATE_MEMBERSHIP_TEXT = 'Activate Membership';
export const DELETE_MEMBERSHIP_TEXT = 'Delete Membership';
export const DISABLE_USER_TEXT = 'Disable User';
export const ENABLE_USER_TEXT = 'Enable User';
export const RESET_MFA_TEXT = 'Reset MFA';
export const MFA_RESET_SUCCESS = 'MFA reset successfully';
export const MFA_RESET_FAILED = 'MFA reset failed';

export const MfaEnabledRoles = [
  'SUPER_ADMIN_ORG',
  'ORGANIZATION_ADMIN',
  'AUTHOR',
  'ADMIN',
  'RESTRICTED_SCHOOL_ADMIN',
  'TDC',
  'ALEF_CONSOLE_SUPPORT',
];

export const hasMfaEnabledRole = (roleNames) =>
  Array.isArray(roleNames) &&
  roleNames.some((role) => MfaEnabledRoles.includes(role));

export const CONFIRM_ACTIVATION_MESSAGE = 'Confirm Activation';
export const CONFIRM_DEACTIVATION_MESSAGE = 'Confirm Deactivation';

export const ACTIVATE_ORGANISATION_CONFIRMATION =
  'Are you sure you want to activate this organisation?';
export const DEACTIVATE_ORGANISATION_CONFIRMATION =
  'Are you sure you want to deactivate this organisation?';

export const QUICK_ACCESS = 'Quick Access';
export const SYSTEM_ROLES = 'System Roles';

export const MODULE = 'Module';
export const PERMISSIONS = 'Permissions';
export const EDIT_PERMISSIONS = 'Edit Permissions';
export const ADD_PERMISSIONS = 'Add Permissions';
export const SAVE_CHANGES = 'Save Changes';
export const SEARCH_PERMISSIONS_PLACEHOLDER = 'Search permissions';
export const PERMISSION_NOT_FOUND = 'No permissions found with text';
export const CREATE_NEW_ROLE = 'Create New Role';
export const EDIT_ROLE = 'Edit Role';
export const VIEW_ROLE = 'View Role';
export const CREATE_ROLE = 'Create Role';

export const FILL_FORM_TO_ADD_ROLE = 'Fill the form to add a role';
export const FILL_FORM_TO_ADD_MEMBER = 'Fill the form to add a member';
export const FILL_FORM_TO_EDIT_MEMBER = 'Fill the form to edit a member';

export const ASSIGNED_PERMISSIONS = 'Assigned Permissions';
export const NO_PERMISSIONS_ASSIGNED = 'No permissions assigned.';
export const ROLE_INFORMATION_TITLE = '1. Role Information';
export const PERMISSIONS_TITLE = '2. Permissions';

export const NO_CUSTOM_ROLES_TITLE_MESSAGE = 'No Custom Roles Yet.';
export const NO_CUSTOM_ROLES_DESCRIPTION_MESSAGE =
  'Start by creating a new role.';
export const ROLE_NAME = 'Role Name';
export const ORGANIZATION = 'Organization';

export const RNP_DESCRIPTION_TITLE = 'Description:';
export const RNP_PERMISSIONS_TITLE = 'Permissions:';

export const NO_SYSTEMS_ROLES_TITLE_MESSAGE =
  'Roles and Permission Area is Empty!';
export const NO_SYSTEMS_ROLES_DESCRIPTION_MESSAGE = 'Start by adding new role!';

export const ROLE_SUCCESSFULLY_CREATED = `":roleName" was successfully created.`;
export const ROLE_SUCCESSFULLY_UPDATED = `":roleName" is successfully updated.`;
export const ROLE_SUCCESSFULLY_DELETED = `":roleName" is successfully deleted.`;
export const EXPORT_CUSTOM_ROLES = 'Export';
export const IMPORT_CUSTOM_ROLES = 'Import';
export const IMPORT_CUSTOM_ROLES_TITLE = 'Import Custom Roles';
export const CUSTOM_ROLES_EXPORT_SUCCESS =
  'Custom roles exported successfully.';
export const CUSTOM_ROLES_EXPORT_FAILED = 'Failed to export custom roles.';
export const CUSTOM_ROLES_IMPORT_SUCCESS =
  ':created created, :updated updated, :failed failed.';
export const CUSTOM_ROLES_IMPORT_FAILED = 'Failed to import custom roles.';
export const CUSTOM_ROLES_IMPORT_MISSING_ROLE_NAME =
  'CSV is missing required column: RoleName.';
export const CUSTOM_ROLES_IMPORT_MISSING_DESCRIPTION =
  'CSV is missing required column: Description.';
export const CUSTOM_ROLES_IMPORT_MISSING_PERMISSIONS =
  'CSV is missing required column: Permissions.';
export const CUSTOM_ROLES_IMPORT_EMPTY_FILE = 'CSV file is empty.';
export const CUSTOM_ROLES_IMPORT_NO_ROLE_ROWS =
  'CSV must contain at least one role row.';
export const CUSTOM_ROLES_EXPORT_FETCHING_ROLES = 'Fetching roles...';
export const CUSTOM_ROLES_EXPORT_PROCESSING_ROLE =
  'Exporting role :current of :total...';
export const CUSTOM_ROLES_EXPORT_BUILDING_FILE = 'Building export file...';
export const CUSTOM_ROLES_IMPORT_READING_FILE = 'Reading CSV file...';
export const CUSTOM_ROLES_IMPORT_LOADING_PERMISSIONS = 'Loading permissions...';
export const CUSTOM_ROLES_IMPORT_PROCESSING_ROLE =
  'Importing role :current of :total...';
export const CUSTOM_ROLES_IMPORT_REFRESHING = 'Refreshing roles list...';
export const IMPORT_CUSTOM_ROLES_SUMMARY_TITLE = 'Import Summary';
export const IMPORT_ROLE_CREATED = 'Created';
export const IMPORT_ROLE_UPDATED = 'Updated';
export const IMPORT_ROLE_FAILED = 'Failed';
export const IMPORT_ROLE_MISSING_PERMISSIONS =
  'At least one permission is required.';
export const IMPORT_ROLE_CREATED_MESSAGE = 'Role created successfully.';
export const IMPORT_ROLE_UPDATED_MESSAGE = 'Role updated successfully.';
export const ROLES_BULK_UPLOAD_TEMPLATE_FILENAME =
  'Roles_BulkUpload_Template.csv';
export const ROLES_BULK_UPLOAD_EXPORT_FILENAME = 'Roles_BulkUpload_Export.csv';
export const SEARCH_BOX_PLACEHOLDER = 'Search...';
export const MEMBER_SUCCESSFULLY_ADDED = 'Member was successfully added.';
export const MEMBER_SUCCESSFULLY_UPDATED = 'Member was successfully updated.';
export const MEMBERSHIP_SUCCESSFULLY_UPDATED =
  'Membership was successfully updated';
export const MEMBERSHIP_SUCCESSFULLY_REMOVED =
  'Membership removed successfully.';

export const ORG_SUCCESSFULLY_DEACTIVATED_MESSAGE =
  'Organisation Deactivated successfully.';
export const ORG_SUCCESSFULLY_ACTIVATED_MESSAGE =
  'Organisation Activated successfully.';

export const NO_MEMBERS_TITLE_MESSAGE = 'Members Area is Empty!';
export const NO_MEMBERS_DESCRIPTION_MESSAGE = 'Start by adding new Member!';

export const NO_ORG_MEMBERS_TITLE_MESSAGE = 'Members list is Empty!';
export const NO_ORG_MEMBERS_DESCRIPTION_MESSAGE =
  'Start by adding new members!';

export const NO_ORGANISATIONS_TITLE_MESSAGE = 'Organisation Area is Empty!';
export const NO_ORGANISATIONS_DESCRIPTION_MESSAGE =
  'Start by adding new organisation!';

export const REMOVE_USER_CONFIRMATION_MESSAGE =
  'Are you sure you want to remove this user from the organization ?';
export const REMOVING_MEMBERSHIP_MESSAGE =
  'Removing membership from organisation...';

export const NO_ADMINS_TITLE_MESSAGE = 'Admins Area is Empty!';

export const VIEW_ADMIN_TITLE = 'View Admin';
export const EDIT_ADMIN_TITLE = 'Edit Admin';
export const EDIT_ADMIN_DESCRIPTION = 'Fill the form to edit admin';
export const GENERAL_INFORMATION = 'General Information';
export const FIRST_NAME = 'First Name';
export const LAST_NAME = 'Last Name';
export const PASSWORD = 'Password';
export const CONFIRM_PASSWORD = 'Confirm Password';
export const CONTACT_EMAIL = 'Contact e-mail';
export const ADMIN_UPDATED_SUCCESSFULLY = 'Admin updated successfully.';
export const SEND_RESET_PASSWORD_LINK = 'Send reset password link?';
export const EMAIL_EXISTS = 'Email already exists. User cannot be updated';
export const RESET_PASSWORD = 'Reset Password!';
export const RESET_PASSWORD_CONFIRMATION_STRING =
  'Are you sure you want to send reset password link to :email?';
export const ADD_ADMIN = 'Add Admin';
export const ADD_ADMIN_DESCRIPTION = 'Fill the form to add admin';
export const ROLES = 'Roles';
export const ADMIN_CREATED_SUCCESSFULLY = 'Admin created successfully.';
export const ADMIN_ALREADY_EXISTS = 'Admin already exists.';
export const CHECK_EMAIL = 'Check Email';
export const WRONG_EMAIL_FORMAT = 'Wrong e-mail format';
export const ADMIN_EXIST_MESSAGE = 'Admin already exists, do you want to edit?';
export const PLEASE_ENTER_EMAIL = 'Please enter email';
export const ADMIN_WITH_DIFF_ROLE_EXIST_MESSAGE =
  'Email already exist. No admin account can be created.';
export const TENANT = 'Tenant';
export const SHARED_TENANT = 'shared';

// Organisation Settings Page
export const GENERAL_SETTINGS = 'General Settings';
export const PRODUCT_SETTINGS = 'Product Settings';
export const SETTINGS_UPDATED_SUCCESS_MESSAGE =
  'Settings updated successfully.';
export const SETTINGS_INPUT_INVALID_MESSAGE = 'Please enter valid input value';
export const CONTENT_MANAGEMENT_SETTING = 'Content management setting';
export const CONTENT_REPOSITORY = 'Content Repository';
export const CONTENT_REPOSITORY_TOOLTIP_TEXT =
  'organizations pool of content items';
export const WARNING_TITLE = 'Remove Content Repository Mapping';
export const WARNING_MESSAGE =
  'Content Repository might have some associated progress.\n\t\t\tDo you want to remove the mapping from this org?';

export const AVATAR_UPLOAD = 'Avatar Upload';
export const AVATARS = 'Avatars';
export const UPLOAD_FILE = 'Upload File';
export const UPLOAD_HISTORY = 'Upload History';
export const FILE_NAME = 'File Name';
export const STAR_COST = 'Star Cost';
export const CATEGORY = 'Category';
export const GENDER = 'Gender';
export const EXPIRY_DATE = 'Expiry Date';
export const ENABLED = 'Enabled';
export const DISABLED = 'Disabled';
export const DELETED = 'Deleted';
export const NO_AVATAR_HISTORY_TITLE = 'No avatars uploaded';
export const MALE = 'Male';
export const FEMALE = 'Female';
export const OTHER = 'Other';
export const CHARACTERS = 'Characters';
export const NATURE = 'Nature';
export const OTHERS = 'Others';
export const AVATAR_NOT_FOUND = 'Avatar not found';
export const UPLOAD_FILE_DESCRIPTION =
  'Upload a file and fill in the details below';
export const SELECT_TENANT = 'Select Tenant';
export const SELECT_ORGANISATION = 'Select Organisation';
export const SELECT_ASSET_CATEGORY = 'Select Category';
export const SELECT_GENDER = 'Select Gender';
export const NEVER = 'Never';
export const INCLUDE_FUTURE_ORGANISATION = 'Include Future orgs';
export const ASSET_CATEGORY = 'Asset Category*';

export const DELETE_AVATARS_TITLE = 'Delete Avatars';
export const DELETE_AVATARS_DESCRIPTION =
  'Are you sure you want to delete these avatars?';
export const deleteAvatarTitle = (name) => `Delete Avatar ${name}`;
export const deleteAvatarDescription = (name) =>
  `Are you sure you want to delete ${name}?`;

export const NAV_ALEF_CONSOLE = 'ALEF CONSOLE';
export const NAV_ORGANIZATIONS = 'Organizations';
export const NAV_COURSE_MAPPING = 'Course Mapping';
export const NAV_ALL_USERS = 'All Users';
export const NAV_ESIS_LOGS = 'ESIS Logs';
export const NAV_STUDENT_AVATARS = 'Student Avatars';
export const NAV_SECTION_PLATFORM = 'Platform and Configuration';
export const NAV_SECTION_ACCESS = 'Access and User Management';
export const NAV_SECTION_SYSTEM = 'System and Maintenance';
export const NAV_COLLAPSE_MENU = 'Collapse navigation menu';
export const NAV_EXPAND_MENU = 'Expand navigation menu';
